import { Button } from '@ps/sports-ui-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Link from '@swf/components/Link/Link';
import { Message } from '@swf/sports/components';

import {
  TXTWCL_Return_To_Promotions,
  TXTWCL_We_are_having_trouble_retrievi_ELL
} from './NoPromotionMessage.messages.json';
import styles from './NoPromotionMessage.scss';

const NoPromotionMessage: React.FC = () => (
  <div className={styles.wrapper}>
    <Message message={<Translation {...TXTWCL_We_are_having_trouble_retrievi_ELL} />}>
      <Button as={Link} alias="sportsPromotions">
        <Translation {...TXTWCL_Return_To_Promotions} />
      </Button>
    </Message>
  </div>
);

export default NoPromotionMessage;
